import { render, staticRenderFns } from "./memoryTable.vue?vue&type=template&id=fcbc92ac&scoped=true&"
import script from "./memoryTable.vue?vue&type=script&lang=js&"
export * from "./memoryTable.vue?vue&type=script&lang=js&"
import style0 from "./memoryTable.vue?vue&type=style&index=0&id=fcbc92ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbc92ac",
  null
  
)

export default component.exports